// extracted by mini-css-extract-plugin
export default {"create":"styles-module__create__src-labstep-web-components-Thread-Form-_wpfWN","container":"styles-module__container__src-labstep-web-components-Thread-Form-_wKB2h"};